import { getId } from '../../common/utilities.js';
import { FRONTEND_PROPERTY_NAME } from '../../common/constants.js';
export function validateRichAssetUnknown(richAsset, accept) {
    // Get the parent Node to which this belongs. The full path to that is
    // RichAssetUnknown => RichAsset => Node
    const parentNode = richAsset?.$container?.$container;
    const idField = getId(parentNode);
    accept('error', `Unknown rich asset type '${richAsset.type}' found.`, {
        node: richAsset,
        data: {
            id: idField?.id?.value,
            nodeNumber: parentNode?.name,
            propertyName: FRONTEND_PROPERTY_NAME.RICH_ASSET_TYPE,
        },
    });
}
//# sourceMappingURL=unknown.js.map